function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS BaseCard INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var UUBaseCard = function UUBaseCard(_ref) {
  var noBorder = _ref.noBorder,
    children = _ref.children,
    className = _ref.className,
    id = _ref.id;
  var cardClass = function cardClass() {
    return classNames({
      rounded: true,
      'border-solid border border-medium-border-blue': !noBorder
    }, className);
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, id ? {
    id: id
  } : {}, {
    className: cardClass()
  }), children);
};
UUBaseCard.propTypes = {
  noBorder: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string
};
UUBaseCard.defaultProps = {
  id: '',
  className: '',
  children: [],
  noBorder: false
};
UUBaseCard.displayName = 'UUBaseCard';
export default UUBaseCard;